export enum TabEnumAllocations {
    Unrealized = 'unrealized',
    Realized = 'realized',
    RealizedGainLoss = 'realized-gain-loss',
    CapitalGainLoss = 'capital-gain-loss',
    TotalGainLoss = 'total-gain-loss',
}
